export default __webpack_public_path__ + "static/media/kv.87c25aa0.jpeg";